module.exports = __webpack_public_path__ + "img/checkmate.18fc4331.png";